import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'shared/utils/axiosBaseQuery'
import storeTags from '../constants/storeTags'

// Base RTK Query API that endpoints are injected into across the app.
//
// This lives in its own module (rather than store.ts) on purpose: slices and
// services need `emptySplitApi`, but store.ts also imports those slices to build
// the reducer registry. Defining the api here breaks that circular import so a
// slice loading before store.ts finishes can no longer trip a temporal-dead-zone
// ReferenceError in store.ts's reducer map.
export const emptySplitApi = createApi({
  baseQuery: axiosBaseQuery({ baseUrl: '/' }),
  refetchOnFocus: true,
  tagTypes: storeTags,
  endpoints: () => ({}),
})
